/**
 * Megamenu functionality
 * Handles hover and click interactions for megamenu dropdowns
 */

const initMegamenu = () => {
    const megamenuItems = document.querySelectorAll('.hover-mega');

    if (!megamenuItems.length) {
        return;
    }


    // megamenuItems.forEach((item) => {
    //     const dropdown = item.querySelector('.hm-dropdown');
    //     if (!dropdown) {
    //         return;
    //     }

    //     const menuLink = item.querySelector('a');
    //     let hoverTimeout;

    //     // Handle mouse enter
    //     item.addEventListener('mouseenter', () => {
    //         clearTimeout(hoverTimeout);
    //         dropdown.style.display = 'grid';
    //         // Force reflow to ensure display is set before transition
    //         dropdown.offsetHeight;
    //         dropdown.style.opacity = '1';
    //         dropdown.style.transform = 'translateY(0)';
    //     });

    //     // Handle mouse leave
    //     item.addEventListener('mouseleave', () => {
    //         hoverTimeout = setTimeout(() => {
    //             dropdown.style.opacity = '0';
    //             dropdown.style.transform = 'translateY(15px)';
    //             // Hide after transition completes
    //             setTimeout(() => {
    //                 if (dropdown.style.opacity === '0') {
    //                     dropdown.style.display = 'none';
    //                 }
    //             }, 400);
    //         }, 100);
    //     });

    //     // Keep dropdown open when hovering over it
    //     dropdown.addEventListener('mouseenter', () => {
    //         clearTimeout(hoverTimeout);
    //         dropdown.style.opacity = '1';
    //         dropdown.style.transform = 'translateY(0)';
    //     });

    //     dropdown.addEventListener('mouseleave', () => {
    //         dropdown.style.opacity = '0';
    //         dropdown.style.transform = 'translateY(15px)';
    //         setTimeout(() => {
    //             if (dropdown.style.opacity === '0') {
    //                 dropdown.style.display = 'none';
    //             }
    //         }, 400);
    //     });

    //     // Mobile: Toggle on click
    //     if (window.innerWidth < 992) {
    //         if (menuLink) {
    //             menuLink.addEventListener('click', (e) => {
    //                 e.preventDefault();
    //                 const isOpen = dropdown.style.display === 'grid';

    //                 // Close all other megamenus
    //                 megamenuItems.forEach((otherItem) => {
    //                     if (otherItem !== item) {
    //                         const otherDropdown = otherItem.querySelector('.hm-dropdown');
    //                         if (otherDropdown) {
    //                             otherDropdown.style.display = 'none';
    //                             otherDropdown.style.opacity = '0';
    //                         }
    //                     }
    //                 });

    //                 // Toggle current megamenu
    //                 if (isOpen) {
    //                     dropdown.style.opacity = '0';
    //                     dropdown.style.transform = 'translateY(15px)';
    //                     setTimeout(() => {
    //                         dropdown.style.display = 'none';
    //                     }, 400);
    //                 } else {
    //                     dropdown.style.display = 'grid';
    //                     dropdown.offsetHeight; // Force reflow
    //                     dropdown.style.opacity = '1';
    //                     dropdown.style.transform = 'translateY(0)';
    //                 }
    //             });
    //         }
    //     }
    // });

    // // Handle window resize
    // let resizeTimeout;
    // window.addEventListener('resize', () => {
    //     clearTimeout(resizeTimeout);
    //     resizeTimeout = setTimeout(() => {
    //         // Reset all megamenus on resize
    //         megamenuItems.forEach((item) => {
    //             const dropdown = item.querySelector('.hm-dropdown');
    //             if (dropdown) {
    //                 dropdown.style.display = 'none';
    //                 dropdown.style.opacity = '0';
    //                 dropdown.style.transform = 'translateY(15px)';
    //             }
    //         });
    //     }, 250);
    // });
};

export default initMegamenu;





jQuery(document).ready(function($) {

    /* ===============================
     * TOP LEVEL MENU CLICK
     * =============================== */
    $(document).on('click', '.hover-mega > a', function(e) {

        const $mega = $(this).closest('.hover-mega');

        // 🔥 no-sub → direct link
        if ($mega.hasClass('no-sub')) {
            return;
        }

        e.preventDefault();

        const linkUrl = $(this).attr('href');
        const linkText = $(this).text().trim();

        // close others
        $('.hover-mega').not($mega).removeClass('is-open');

        // toggle current
        $mega.toggleClass('is-open');

        // update hm-left
        $mega.find('.hm-left h3').text(linkText);
        $mega.find('.hm-left .btn').attr('href', linkUrl);

        // 🔥 IMPORTANT: update submenu links ONLY for this open mega
        updateSubmenuLinks($mega);
    });


    /* ===============================
     * UPDATE SUBMENU LINKS LOGIC
     * =============================== */
    function updateSubmenuLinks($mega) {

        if (!$mega.hasClass('is-open')) { return; }

        $mega.find('.dynamic-submenu > li').each(function() {

            const $li = $(this);
            const $a = $li.children('a');
            const hasSub = $li.children('.sub-submenu').length > 0;

            if (hasSub) {
                
                $a.attr('href', '#');

                $a.off('click.sub').on('click.sub', function(e) {
                    e.preventDefault();
                });

            } else {
                
                const originalHref = $a.data('href');

                if (originalHref) {
                    $a.attr('href', originalHref);
                }

                $a.off('click.sub');
            }
        });
    }


    /* ===============================
     * STORE ORIGINAL LINKS (ONCE)
     * =============================== */
    $('.dynamic-submenu > li > a').each(function() {
        const $a = $(this);
        if (!$a.data('href')) {
            $a.data('href', $a.attr('href'));
        }
    });


    /* ===============================
     * HM-DROPDOWN CLOSE
     * =============================== */
    $(document).on('click', '.hm-dropdown', function() {
        $(this).closest('.hover-mega').removeClass('is-open');
    });

    $(document).on('click', '.hm-dropdown *', function(e) {
        e.stopPropagation();
    });


    /* ===============================
 * SUBMENU ACTIVE STATE (FIXED)
 * =============================== */
    $(document).on(
        'click',
        '.hover-mega.is-open .dynamic-submenu > li > a',
        function(e) {

            const $a = $(this);
            const $li = $a.parent('li');
            const $mega = $li.closest('.hover-mega');

            if ($li.children('.sub-submenu').length === 0) {
                return;
            }

            e.preventDefault();

            $mega.find('.dynamic-submenu > li').removeClass('active');
            $li.addClass('active');
        },
    );



});

jQuery(document).ready(function($) {

    $('.dynamic-submenu > li').each(function() {

        const $parentLi = $(this);
        const $parentLink = $parentLi.children('a');
        const parentText = $parentLink.text().trim();
        const parentHref = $parentLink.attr('href');

        const $subMenu = $parentLi.children('.sub-submenu');

        if ($subMenu.length && !$subMenu.find('.default-parent').length) {

            const defaultItem = `
        <li class="default-parent">
          <a href="${parentHref}">
            ${parentText}
          </a>
        </li>
      `;

            // TOP ma add karo
            $subMenu.prepend(defaultItem);
        }

    });

});


jQuery(document).ready(function($) {

    $('.sub-submenu').each(function() {
        const $submenu = $(this);

        const $otherItems = $submenu.children('li').not('.default-parent');
        if ($otherItems.length) {
            $otherItems.wrapAll('<div class="sub-wrapper"></div>');
        }

    });

});

jQuery(document).ready(function($) {

    $('.dynamic-submenu > li > a').on('click', function(e) {

        const $li = $(this).parent('li');

        // no-sub = normal link
        if ($li.hasClass('no-sub')) {
            return;
        }

        e.preventDefault();

        const $hmCenter = $li.closest('.hm-center');

        // remove active from other li
        $li.siblings(':not(.no-sub)').removeClass('active');

        $li.addClass('active');

        $hmCenter.addClass('bg-active');
    });

});




jQuery(document).ready(function($) {

    /* ==================================
     * DEFAULT ACTIVE (page load + menu open)
     * ================================== */
    function setDefaultActive($mega) {
        if ($mega.find('.dynamic-submenu > li.active').length === 0) {
            $mega.find('.dynamic-submenu > li').first().addClass('active');
        }
    }

    $('.hover-mega.is-open').each(function() {
        setDefaultActive($(this));
    });

    $(document).on('click', '.hover-mega > a', function() {
        const $mega = $(this).closest('.hover-mega');

        setTimeout(function() {
            if ($mega.hasClass('is-open')) {
                setDefaultActive($mega);
            }
        }, 0);
    });

    /* ==================================
     * SUBMENU CLICK 
     * ================================== */
    $(document).on(
        'click',
        '.hover-mega.is-open .dynamic-submenu > li > a',
        function(e) {

            const $li = $(this).parent('li');
            const $mega = $li.closest('.hover-mega');

            if ($li.children('.sub-submenu').length === 0) {
                return;
            }

            e.preventDefault();

            $mega.find('.dynamic-submenu > li').removeClass('active');
            $li.addClass('active');
        },
    );

});
jQuery(document).ready(function($) {

    const currentUrl = window.location.href;

    $('.sub-wrapper li a').each(function() {

        const linkUrl = this.href;

        if (currentUrl === linkUrl) {
            $(this).closest('li').addClass('active-menu');
        }

    });

});



